import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalAllowDownload = ({
  allowDownload,
  userCanDownload,
  hasRestrictedFiles,
  handleChange,
}) => {
  const intl = useIntl();

  if (!userCanDownload && !hasRestrictedFiles) {
    return null;
  }

  return (
    <div className={classnames('share-allow-download share-setting', { error: (!userCanDownload && hasRestrictedFiles) })}>
      {userCanDownload && (
        <Label for="inpAllowDownload" className={classnames('switch', { disabled: !canUserManageShare() })}>
          <span>
            {intl.formatMessage({ defaultMessage: 'Allow downloads' })}
            <HelpIcon id="share-allow-downloads">
              {intl.formatMessage({ defaultMessage: 'Toggle off to make files in this share, view only.' })}
            </HelpIcon>
          </span>
          <div className="share-setting-switch-wrapper">
            <UpgradePlanButton feature="share-allow-download" simple={true} />
            {userHasFeature('share-allow-download') && (
              <div className="switch-control input-inner">
                <Input
                  type="checkbox"
                  name="allow-download"
                  id="inpAllowDownload"
                  value={true}
                  checked={allowDownload}
                  onChange={handleChange}
                  disabled={!canUserManageShare()}
                />
                <i />
              </div>
            )}
          </div>
        </Label>
      )}
      {hasRestrictedFiles && (
        <div className="restricted-files-notice">
          {intl.formatMessage({ defaultMessage: 'Your share contains restricted files. Downloading will be disabled.' })}
        </div>
      )}
    </div>
  );
};

ShareModalAllowDownload.propTypes = {
  allowDownload: PropTypes.bool.isRequired,
  userCanDownload: PropTypes.bool.isRequired,
  hasRestrictedFiles: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalAllowDownload;
